<template>
  <va-modal
    id="eventApprovalModal"
    ref="eventApprovalModal"
    class="evollu-form"
    size="medium"
    :value="isOpen"
    :noOutsideDismiss="true"
    :okText="$t('activities_agenda.actions.approve')"
    :dangerText="$t('activities_agenda.actions.reject')"
    :cancelText="$t('modals.buttons.cancel')"
    :showOkay="showActions || hasEventApprovalPermissions "
    :showDelete="(showActions || hasEventApprovalPermissions && !isSubmiting)"
    :showCancel="true"
    :okDisabled="isSubmiting"
    :cancelDisabled="isSubmiting"
    @ok="handleApprovalEventRequest(true)"
    @cancel="cancel"
    @remove="handleApprovalEventRequest(false)">
    <div slot="header" class="modal-title">
      {{ modalTitle }}
    </div>

    <div class="row">
      <h5 class="col-12"> {{$t('activities_agenda.agenda.event_section')}} </h5>
      <div class="col-6 mt-2">
        <p>{{$t("entities.activities.revision.activity")}}: <span class="is-bold"> {{ $t(`entities.activity_types.${event.activity.id}`)}} </span> </p>
        <p>{{ $t("activities_agenda.agenda.origin_entity") }}: <span class="is-bold">{{ event.originEntity.name }}</span></p>
        <p>{{ $t("facility.inputs.entity") }}: <span class="is-bold">{{ event.entity.name }}</span></p>
        <p>{{ $t("agenda.availability.start") }}: <span class="is-bold">{{ moment(event.start, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss') }}</span></p>
      </div>
      <div class="col-6 mt-2">
        <p>{{$t("agenda.appointments.appointment_type")}}: <span class="is-bold"> {{$t(`activities_agenda.agenda.booking_types.${event.bookingType.slug}`)}} </span> </p>
        <p>{{ $t("activities_agenda.agenda.origin_facility") }}: <span class="is-bold">{{ event.originFacility.name }}</span></p>
        <p>{{ $t("agenda.appointments.facility") }}: <span class="is-bold">{{ event.facility.name }}</span></p>
        <p>{{ $t("agenda.availability.end") }}: <span class="is-bold">{{ moment(event.end, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss') }}</span></p>
      </div>
    </div>
    <div class="row mt-3">
      <h5 class="col-12"> {{$t('activities_agenda.agenda.person_section')}} </h5>
      <div class="col-6 mt-2">
        <p>{{ $t("accounts.name") }}: <span class="is-bold">{{ handleSelectedPersonName }}</span></p>
        <p>{{ $t("people.inputs.mobile-phone") }}: <span
          class="is-bold">{{ event.person.mobilePhone }}</span></p>
        <p>{{ $t("patients.inputs.taxCard") }}: <span class="is-bold">{{ event.person.taxNr }}</span></p>
      </div>
      <div class="col-6 mt-2">
        <p>{{ $t("clinical.people.birthday") }}: <span
          class="is-bold">{{ moment(event.person.birthdate).format('YYYY-MM-DD') }}</span></p>
        <p>{{ $t("accounts.email") }}: <span class="is-bold">{{ event.person.email }}</span></p>
        <p>{{ $t("patients.inputs.healthCard") }}: <span
          class="is-bold">{{ event.person.healthNr }}</span></p>
      </div>
    </div>
  </va-modal>
</template>

<script>

import { ActivitiesAgendaService } from "@/api/ActivitiesAgendaService";

export default {
  props: {
    service: {
      type: Object,
      required: true,
    },
    event: {
      type: Object,
      required: false
    },
    agendaEvents: {
      type: Array,
      required: false,
      default: []
    },
    showActions: {
      type: Boolean,
      required: false,
      default: false
    },
    title: {
      type: String,
      required: false,
      default: null
    }
  },
  data() {
    return {
      isOpen: false,
      isSubmiting: false,
    }
  },
  mounted() {
    this.isOpen = true
  },
  methods: {
    cancel: function() {
      setTimeout(() => {
        this.$emit("cancel");
      }, 200);
    },
    handleApprovalEventRequest: async function(approved) {
      if(approved === null || approved === undefined) {
        return
      }
      this.isSubmiting = true
      try {
        const response = await ActivitiesAgendaService.approve(this.event.id, {approved: approved})
        if(approved) {
          this.showToast(this.$t('activities_agenda.agenda.event_approved_success'), this.$store.state.successToastOptions)
        } else {
          this.showToast(this.$t('activities_agenda.agenda.rejected_success'), this.$store.state.successToastOptions)
        }

        this.$emit('eventApproved')
      } catch (err) {
        console.log(err)
        this.isSubmiting = false
        this.showToast(this.$t('activities_agenda.agenda.approval_error'), this.$store.state.errorToastOptions)
      }
    },
  },
  computed: {
    modalTitle: function() {
      return this.title ? this.title : this.$t('activities_agenda.approval.title')
    },
    handleSelectedPersonName: function() {
      if (!this.event.person) return "N/A";
      let str = "";
      str += this.event.person.firstName;
      if (this.event.person.lastName) {
        str += " ";
        str += this.event.person.lastName;
      }
      return str;
    },
    hasEventApprovalPermissions: function() {
      return this.service.user_permissions.some(elem => elem.info_type === 110 && elem.access_type >= 2 && elem.entity_id === parseInt(this.event.entity.id))
    }
  }
};
</script>

<style scoped>

</style>
